export enum CertDirection {
    ProductLK = 1,
    CyberSecurity = 2,
}
